import { createPortal } from 'react-dom'
import React, { useContext } from 'react'
import { useLang } from '_metronic/i18n/Metronici18n'
import { QuotationFormContext } from '../Context'
import { Modal } from 'react-bootstrap'

interface Props {
	onSelectItemType: (itemType: 'product' | 'additional') => void
}

const AddItemTypeSelection: React.FC<Props> = ({ onSelectItemType }) => {
	const currentLanguage = useLang()
	const modalsRoot = document.getElementById('root-modals') || document.body
	const { showItemTypeSelection, setShowItemTypeSelection } = useContext(QuotationFormContext)

	const itemClassName =
		'item bg-zeroloss-grey-600 h-100 cursor-pointer w-100 border border-kumpack-grey-200 p-10 text-center shadow d-flex flex-column align-items-center justify-content-center hover-enabled transition-300'

	return createPortal(
		<Modal
			id="document_quotation_form_add_item_type_selection"
			size="sm"
			tabIndex={-1}
			aria-hidden="true"
			dialogClassName="modal-dialog modal-dialog-centered mw-400px"
			show={showItemTypeSelection}
			onHide={() => {
				setShowItemTypeSelection(false)
			}}
			backdrop={true}>
			<div className="modal-content">
				<div className="modal-body py-lg-10 px-lg-10 min-h-200px">
					<h1 className="text-kumopack-grey-900 text-center">
						{currentLanguage === 'en' ? 'Select item type' : 'เลือกประเภทรายการที่ต้องการเพิ่ม'}
					</h1>

					<div className="mt-10 card min-h-200px">
						<div className="card-body h-100 p-0">
							<div
								className="d-flex flex-column flex-lg-row align-items-center h-200px"
								style={{ gap: '12px' }}>
								<div className={itemClassName} onClick={() => onSelectItemType('product')}>
									<img
										src="/media/icons/kumopack/coins-01.svg"
										alt="Product Icon"
										className="w-30px h-30px mb-1"
									/>
									{currentLanguage === 'en' ? 'Product' : 'สินค้า'}
								</div>
								<div className={itemClassName} onClick={() => onSelectItemType('additional')}>
								<img
										src="/media/icons/kumopack/dotpoints-02.svg"
										alt="Product Icon"
										className="w-30px h-30px mb-1"
									/>
									{currentLanguage === 'en' ? 'Additional' : 'เพิ่มเติม'}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<style>{`
				#document_quotation_form_add_item_type_selection .item {
					border-radius: 6px !important;
				}

            	#document_quotation_form_add_item_type_selection .item:hover {
					border-color: #a152bd !important;
				}
            `}</style>
		</Modal>,
		modalsRoot
	)
}

export default AddItemTypeSelection
